module.exports = __webpack_public_path__ + "img/rockestate_logo_aligned.9422d248.svg";